import React from 'react'

import StarRating from './StarRating'
/*
Displays a review - typically submitted by some other user.
Used to demonstrate to users what a "good" review might look like.

TODO: support for truncating long reviews

the h5 here was pretty darn arbitrary

*/

const SampleReview = ({
  title,
  displayDate,
  reviewBody,
  nickname,
  rating,
  outOf,
}) => {
  return (
    <>
      <div className="sample-review">
        <StarRating rating={rating} outOf={outOf} />
        <h5 className="review-title">{title}</h5>
        <div className="review-date">{displayDate}</div>
        <div
          className="review-body"
          dangerouslySetInnerHTML={{ __html: reviewBody }}
        />
        <div className="review-nickname">{nickname}</div>
      </div>
    </>
  )
}

export default SampleReview
